export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4849.c1af89cd.jpg";